import { createContext } from "react";

export const MenuDisclosureContext = createContext<
  | {
      active: boolean;
    }
  | undefined
>(undefined);
